import React from 'react';
import { connect } from "react-redux";
import { updateData, updateFilterData, updateEditData } from "../actions";
import ControlService from '../../helper/controlservice';

class Website extends React.PureComponent {
    state = {
        touched: false,
        shouldMarkError: false,
        value: ''
    }
    static getDerivedStateFromProps(nextProps) {
        const { control, formid, data } = nextProps;
        var _data = data[formid] && data[formid][control.key] ? data[formid][control.key] : ""
        return {
            value: _data
        }
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.state.value && this.state.value === undefined && this.state.touched === false) {
            this.props.update(this.props.control.key, this.state.value, this.props.formid)
        } else if (prevState.value && this.state.value != prevState.value) {
            ControlService().controlVaildationCheck(this.props);
        }
    }
    handleBlur = (control, data) => {
        this.setState({
            touched: true,
            shouldMarkError: this.shouldMarkError(control, data)
        });
    }
    shouldMarkError(control, data) {

        const validate = ControlService().validate(control, data[control.key]);

        const validation = this.props.data[this.props.formid + "_validation"] ? this.props.data[this.props.formid + "_validation"][control.key] : null;
        const isTouchedOutside = validation ? validation.touched : false;
        const shouldShow = this.state.touched || isTouchedOutside;
        return validate ? !validate : shouldShow;
    }
    componentDidMount() {
        ControlService().controlVaildationCheck(this.props, this.props);
    }
    onValueChange(value, control, action, formid) {
        this.props.update(control.key, value, formid);
    }
    render() {
        const { control, action, formid } = this.props;
        var data = this.props.data[formid] ? this.props.data[formid] : {};
        const shouldMarkError = this.state.shouldMarkError;
        return (
            <div className="form-group">
                {control.label &&
                    <label htmlFor={control.id}>
                        {control.label}
                        {control.require &&
                            <sup className="text-danger font-weight-bold">*</sup>
                        }
                        {control.showhelptext &&
                            <span className={"custom-tooltip"}>
                                <i className={"fa fa-question-circle ml-2 help-text"}></i>
                                <span className={"tooltip tooltip-" + control.helpdirection}>{control.help}</span>
                            </span>
                        }
                    </label>
                }
                <div className="input-group">
                    <div className="input-group-prepend">
                        <span className="input-group-text"><i className="fa fa-globe"></i></span>
                    </div>
                    <input
                        type="text"
                        aria-label={control.label}
                        placeholder={control.placeholder}
                        onChange={(e) => this.onValueChange(e.target.value, control, action, formid)}
                        value={data[control.key]}
                        className={'form-control ' + ((this.shouldMarkError(control, data) && !data[control.key]) || shouldMarkError ? "border-danger" : "")}
                        onBlur={() => { this.handleBlur(control, data); }}
                        disabled={this.props.disabled}
                    />
                </div>
                {(this.shouldMarkError(control, data) && !data[control.key]) &&
                    <small className="form-text text-danger">
                        {control.errormsg ? control.errormsg : 'You must enter a ' + control.label + '.'}
                    </small>
                }
                {(shouldMarkError && data[control.key]) &&
                    <small className="form-text text-danger">You must include a valid {control.label}.</small>
                }
            </div>
        );
    }
}
function bindAction(dispatch) {
    return {
        update: (key, value, storekey) => dispatch(updateData(key, value, storekey)),
        updateEdit: (key, value) => dispatch(updateEditData(key, value)),
        updateFilter: (key, value, key2) => dispatch(updateFilterData(key, value, key2))
    };
}
const mapStateToProps = state => ({
    data: state.formDataReducer,
    filterdata: state.formDataReducer.filterdata,
    editformdata: state.formDataReducer.editformdata,
    token: state.formLoginReducer.token,
    hasErrored: state.formDataReducer.hasErrored,
    isLoading: state.formDataReducer.isLoading
});
export default connect(mapStateToProps, bindAction)(Website);